<div class="form-sec-col basket-panel">
  <mat-toolbar color="accent">
    <mat-toolbar-row>
      Basket
      <span class="toolbar-spacer"></span>
      <button mat-icon-button (click)="closeSidePanel()" class="btn">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>


  <div class="items-container lims-nice-scrollbar">
    @for (item of items; track item; let i = $index) {
      <div>
        <div class="item">
          <div>
            <span class="name">{{item.name}}</span>
          </div>
          <div class="right-item">
            <span class="size">{{item.size}}</span>
            <button class="btn" mat-button color="primary" (click)="deleteItem(i)">
              <i class="material-icons md-20">highlight_off</i>
            </button>
          </div>
        </div>
        <hr class="style">
      </div>
    }
  </div>
  <div class="button-row">
    <button class="space-checkbox" type="button" mat-stroked-button color="warn" (click)="deleteAll()">
      Delete all
    </button>
  </div>
</div>